import { Loader } from '@googlemaps/js-api-loader';
import { styles as googleMapStyles } from '../utils/GoogleMapStyles';

export class GlobalPresenceShortcode {
	constructor() {
		this.map = null;
		this.loader = null;
		this.apiKey = process.env.GOOGLE_API_KEY;
		//this.apiKey = typeof GLOBAL_PRESENCE_SHORTCODE_CONFIG === 'undefined' ? '' : GLOBAL_PRESENCE_SHORTCODE_CONFIG.apiKey;
		this.locations = GlobalPresence.locations;

		this.infoWindowsArray = [];

		this.prevHoveredMarker = null;

		window.initMapCallback = () => {
			this.initMap();
		};

		this.removeThirdPartyScripts();
		this.load();
	}

	load() {
		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=initMapCallback`;
		script.async = true;
		document.head.appendChild(script);
	}

	removeThirdPartyScripts() {
		const script = document.getElementById('gmaps-js-js');
		if (script) {
			script.remove();
		}

		const scripts = document.querySelectorAll(
			'script[src*="maps.googleapis.com"]'
		);
		if (scripts) {
			Array.from(scripts).forEach((element) => {
				element.remove();
			});
		}
	}

	initMap() {
		if (!this.apiKey) {
			return;
		}

		this.map = new google.maps.Map(
			document.getElementById('global-presence-map'),
			{
				center: new google.maps.LatLng(35, -5),
				zoom: 2,
				minZoom: 2,
				styles: googleMapStyles,
				disableDefaultUI: true,
				scrollwheel: false,
				draggable: false,
			}
		);

		this.map.addListener('click', () => {
			if (this.infoWindowsArray.length > 0) {
				for (const infoWindow of this.infoWindowsArray) {
					infoWindow.close();
				}
			}
		});

		this.map.addListener('drag', () => {
			if (this.infoWindowsArray.length > 0) {
				for (const infoWindow of this.infoWindowsArray) {
					infoWindow.close();
				}
			}
		});

		this.addMarkers();
	}

	addMarkers() {
		const locations = this.locations;
		if (!locations) {
			return;
		}

		const markers = [];
		for (let i = 0; i < locations.length; i++) {
			markers[i] = new google.maps.Marker({
				position: {
					lat: locations[i].coordinates.lat,
					lng: locations[i].coordinates.lng,
				},
				map: this.map,
				id: i,
				loc_id: locations[i].coordinates.place_id,
				icon: AssetsPath.url + '/images/map-marker-icon.svg',
				//icon: '/wp-content/themes/nayax/resources/images/map-marker-icon.svg'
			});

			this.infoWindowsArray[i] = this.assignInfoWindowToMarker(
				markers[i]
			);

			markers[i].addListener('mouseover', () =>
				this.markerHoverHandler(this.infoWindowsArray[i], markers[i])
			);
		}
	}

	assignInfoWindowToMarker(marker) {
		return new google.maps.InfoWindow({
			id: marker.id,
			content: this.getInfoWindowContent(marker.id),
		});
	}

	markerHoverHandler(infoWindow, marker) {
		if (this.prevHoveredMarker === null) {
			this.prevHoveredMarker = marker;
		} else if (this.prevHoveredMarker.id !== marker.id) {
			for (const infoWindow of this.infoWindowsArray) {
				infoWindow.close();
			}
		}

		infoWindow.open({
			map: this.map,
			anchor: marker,
		});
	}

	getInfoWindowContent(id) {
		const location = this.locations[id];

		return `
      <div class="info-window">
        <span class="info-window__image"></span>
        <h5 class="info-window__title">${location.name}</h5>
        <h6 class="info-window__subtitle">${location.description}</h6>
      </div>
    `;
	}
}
